import { VendorGeneralChatPage } from "../vendor-general-chat.page";
import { useCentralStore } from "../../../store/Central";
import { useJobStore } from "../../../store/Jobs";

export const VendorGeneralChatPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	const { shareFile, unshareFile, acceptJobRequest, denyJobRequest } =
		useJobStore((s) => ({
			shareFile: s.shareFile,
			unshareFile: s.unshareFile,
			acceptJobRequest: s.acceptJobRequest,
			denyJobRequest: s.denyJobRequest,
		}));

	return (
		<VendorGeneralChatPage
			organizationId={organizationId}
			onShareFile={shareFile}
			onUnshareFile={unshareFile}
			onAcceptJobRequest={acceptJobRequest}
			onDenyJobRequest={denyJobRequest}
		/>
	);
};
